import { useState } from 'react'
import { SoundManager, Music } from '../../lib/sounds'

export function SoundToggleBtn() {
  const [muted, setMuted] = useState(SoundManager.isMuted())

  const toggle = () => {
    const nowMuted = SoundManager.toggle()
    setMuted(nowMuted)
    if (!nowMuted) {
      // don't auto-start music, just unmute
    }
  }

  return (
    <button
      onClick={toggle}
      title={muted ? 'Unmute sounds' : 'Mute sounds'}
      style={{
        background: muted ? 'rgba(255,255,255,0.03)' : 'rgba(255,255,255,0.05)',
        border: `1px solid ${muted ? 'rgba(255,255,255,0.05)' : 'rgba(255,255,255,0.1)'}`,
        borderRadius: 6,
        color: muted ? '#334155' : '#64748b',
        fontSize: 13,
        padding: '4px 8px',
        cursor: 'pointer',
        transition: 'all 0.15s',
        lineHeight: 1,
      }}
    >
      {muted ? '🔇' : '🔊'}
    </button>
  )
}
